/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Original_LanguageInputs */

const en_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Original Language`)
};

const fr_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure la langue d'origine`)
};

const de_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Originalsprache einbeziehen`)
};

const it_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi la lingua originale`)
};

const ru_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить оригинальный язык`)
};

const es_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir idioma original`)
};

const zh_cn2_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包含原始语言`)
};

const ja_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`元の言語を含める`)
};

const hi_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल भाषा शामिल करें`)
};

const pt_pt2_transcript_export_include_original_language = /** @type {(inputs: Transcript_Export_Include_Original_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir idioma original`)
};

/**
* | output |
* | --- |
* | "Include Original Language" |
*
* @param {Transcript_Export_Include_Original_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_original_language = /** @type {((inputs?: Transcript_Export_Include_Original_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Original_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_include_original_language(inputs)
	if (locale === "de") return de_transcript_export_include_original_language(inputs)
	if (locale === "it") return it_transcript_export_include_original_language(inputs)
	if (locale === "ru") return ru_transcript_export_include_original_language(inputs)
	if (locale === "es") return es_transcript_export_include_original_language(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_include_original_language(inputs)
	if (locale === "ja") return ja_transcript_export_include_original_language(inputs)
	if (locale === "hi") return hi_transcript_export_include_original_language(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_include_original_language(inputs)
	return en_transcript_export_include_original_language(inputs)
});